<p-panelMenu [model]="model | panelMenuModelTransform | panelMenuBadge"></p-panelMenu>
